var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{ref:"qrCodeDiv",staticClass:"qrcode",staticStyle:{"width":"200px","height":"200px"},attrs:{"id":"qrCode"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }